import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '123',
        token: localStorage.getItem('token') || '',
        user: {},
        statuses: [],
        project: localStorage.getItem('project') || ''
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, token, user) {
            state.status = 'success'
            state.token = token
            state.user = user
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout_request(state) {
            state.status = ''
            state.token = ''
            state.project = ''
        },
        update_project(state,project){
            state.project = project
            localStorage.setItem('project', project)
        },
        update_statuses(state,statuses){
          state.statuses = statuses
        }
    },
    actions: {
        login({commit}, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                console.log(user);
                let username = user.username
                axios({
                    url: 'https://admin.giraffapp.com/giraffweb_login?' + 'username=' + user.username + '&password=' + user.password,
                    method: 'GET'
                }).then(resp => {
                    console.log('resp', resp)
                    if (resp.data.result) {
                        const token = resp.data.responseData.AuthToken
                        const user = username

                        localStorage.setItem('token', token)
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', token, user)
                        resolve(resp)
                    } else {
                        reject('Authentication Failed, please double check your Builderlynx username and password')
                        commit('auth_error')
                    }

                }).catch(err => {
                    commit('auth_error')
                    localStorage.removeItem('token')
                    localStorage.removeItem('project')
                    reject(err)
                })
            })
        },
        logout({commit}) {
            return new Promise((resolve) => {
                localStorage.removeItem('token')
                localStorage.removeItem('project')

                commit('logout_request')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        updateProject({commit}, project) {
            commit('update_project',project)
        },
        updateStatuses({commit}, statuses) {
          commit('update_statuses',statuses)
        }

    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        authToken: state => state.token,
        projectName: state => state.project,
        statuses: state => state.statuses
    }
})

// TODO: change date
